import { ApiEndpoints } from "../apiEndpoints";
import { requestApi } from "../apiService";
import { Feedback } from "../types/feedback";

export const sendFeedback = async (data: Feedback): Promise<string> => {
  const response = await requestApi({
    url: ApiEndpoints.FEEDBACK,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data,
  });

  return response.data;
};
